var map = {
	"./af.json": 3069,
	"./ar.json": 6726,
	"./bn.json": 8169,
	"./cs.json": 9789,
	"./da.json": 5638,
	"./de.json": 9929,
	"./el.json": 7498,
	"./en.json": 790,
	"./es.json": 8563,
	"./fa.json": 9603,
	"./fr.json": 844,
	"./he.json": 8818,
	"./hi.json": 9493,
	"./hu.json": 4626,
	"./it.json": 504,
	"./ja.json": 8566,
	"./jv.json": 3994,
	"./lt.json": 1560,
	"./nl.json": 3055,
	"./pl.json": 5143,
	"./pt-br.json": 2055,
	"./pt.json": 9898,
	"./ro.json": 4691,
	"./ru.json": 9672,
	"./sk.json": 1941,
	"./sv.json": 3244,
	"./th.json": 2009,
	"./tr.json": 2021,
	"./uk.json": 1754,
	"./zh.json": 6538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5282;